// extracted by mini-css-extract-plugin
export default {"root":"BaseMessage__root--1hCE_","title":"BaseMessage__title--1Z9U0","text":"BaseMessage__text--1qXRn","rootMobile":"BaseMessage__rootMobile--wha6j"};